var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "columns is-multiline d-flex flex-column flex-md-row pr-2 pl-2 sm:pl-0"
    },
    [
      _c(
        "section",
        {
          staticClass: "sidebar column is-full-mobile is-4-tablet is-3-desktop"
        },
        [
          _c("cat-uxo-call-to-action", { staticClass: "mb-4 shape--top" }),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "btn w-100 mb-4", attrs: { href: "/contribute" } },
            [_vm._v("Contribute a New Hazard")]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("cat-uxo-stacked-ads")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "uxo-type column is-offset-1-desktop is-8 p-0" },
        [
          !_vm.loading
            ? [
                _c(
                  "div",
                  { staticClass: "flex w-full flex-col space-y-4" },
                  [
                    _c("div", { staticClass: "flex flex-col space-y-1" }, [
                      _c(
                        "h1",
                        {
                          staticClass:
                            "text-xl font-medium text-gray-800 font-medium capitalize"
                        },
                        [_vm._v(_vm._s(_vm.title))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-sm text-[#E57722]" }, [
                        _vm._v(_vm._s(_vm.meta.total) + " results")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex w-full" }, [
                      _c(
                        "form",
                        {
                          staticClass:
                            "form form-search flex flex-col justify-content-center w-full",
                          attrs: {
                            id: "searchForm",
                            action: "/explosive-hazards/" + _vm.slug
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "field position-relative w-100" },
                            [
                              _c("div", { staticClass: "control" }, [
                                _c("input", {
                                  staticClass: "input w-100 rounded-xl",
                                  attrs: {
                                    name: "query",
                                    type: "text",
                                    placeholder: "What are you looking for?"
                                  },
                                  domProps: { value: _vm.query }
                                })
                              ]),
                              _vm._v(" "),
                              _vm._m(1)
                            ]
                          ),
                          _vm._v(" "),
                          !["terrorist-groups", "incidents"].includes(this.slug)
                            ? _c("div", { staticClass: "flex flex-col" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col sm:flex-row space-x-0 space-y-2 sm:space-y-0 sm:space-x-2 mt-1 sm:mt-2"
                                  },
                                  [
                                    _c(
                                      "select",
                                      {
                                        staticClass: "input rounded-xl",
                                        attrs: {
                                          onchange: "this.form.submit()",
                                          name: "category_id"
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              selected: "",
                                              disabled: "",
                                              value: ""
                                            }
                                          },
                                          [_vm._v("Select a Category")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.filters["categories"],
                                          function(filter) {
                                            return _c(
                                              "option",
                                              {
                                                key: filter.id,
                                                domProps: {
                                                  selected:
                                                    parseInt(
                                                      _vm.formParams[
                                                        "category_id"
                                                      ]
                                                    ) === filter.id,
                                                  value: filter.id
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(filter.name) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          }
                                        )
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        staticClass: "input rounded-xl",
                                        attrs: {
                                          onchange: "this.form.submit()",
                                          name: "country_of_origin_id"
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              selected: "",
                                              disabled: "",
                                              value: ""
                                            }
                                          },
                                          [_vm._v("Country of Origin")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.filters["countries_of_origin"],
                                          function(filter) {
                                            return _c(
                                              "option",
                                              {
                                                key: filter.id,
                                                domProps: {
                                                  selected:
                                                    parseInt(
                                                      _vm.formParams[
                                                        "country_of_origin_id"
                                                      ]
                                                    ) === filter.id,
                                                  value: filter.id
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(filter.name) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          }
                                        )
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        staticClass: "input rounded-xl",
                                        attrs: {
                                          onchange: "this.form.submit()",
                                          name: "country_used_in_id"
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              selected: "",
                                              disabled: "",
                                              value: ""
                                            }
                                          },
                                          [_vm._v("Country Used In")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.filters["countries_used_in"],
                                          function(filter) {
                                            return _c(
                                              "option",
                                              {
                                                key: filter.id,
                                                domProps: {
                                                  selected:
                                                    parseInt(
                                                      _vm.formParams[
                                                        "country_used_in_id"
                                                      ]
                                                    ) === filter.id,
                                                  value: filter.id
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(filter.name) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col sm:flex-row space-x-0 space-y-2 sm:space-y-0 sm:space-x-2 mt-1 sm:mt-2"
                                  },
                                  [
                                    _c(
                                      "select",
                                      {
                                        staticClass: "input rounded-xl",
                                        attrs: {
                                          onchange: "this.form.submit()",
                                          name: "diameter"
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              selected: "",
                                              disabled: "",
                                              value: ""
                                            }
                                          },
                                          [_vm._v("Diameter")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.filters["diameters"],
                                          function(filter) {
                                            return _c(
                                              "option",
                                              {
                                                key: filter.id,
                                                domProps: {
                                                  selected:
                                                    parseInt(
                                                      _vm.formParams["diameter"]
                                                    ) === filter.id,
                                                  value: filter.id
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(filter.name) +
                                                    "\n                                    "
                                                )
                                              ]
                                            )
                                          }
                                        )
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        staticClass: "input rounded-xl",
                                        attrs: {
                                          onchange: "this.form.submit()",
                                          name: "length"
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              selected: "",
                                              disabled: "",
                                              value: ""
                                            }
                                          },
                                          [_vm._v("Length")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.filters["lengths"], function(
                                          filter
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              key: filter.id,
                                              domProps: {
                                                selected:
                                                  parseInt(
                                                    _vm.formParams["length"]
                                                  ) === filter.id,
                                                value: filter.id
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(filter.name) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        staticClass: "input rounded-xl",
                                        attrs: {
                                          onchange: "this.form.submit()",
                                          name: "height"
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              selected: "",
                                              disabled: "",
                                              value: ""
                                            }
                                          },
                                          [_vm._v("Height")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.filters["heights"], function(
                                          filter
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              key: filter.id,
                                              domProps: {
                                                selected:
                                                  parseInt(
                                                    _vm.formParams["height"]
                                                  ) === filter.id,
                                                value: filter.id
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(filter.name) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          this.slug === "terrorist-groups"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex space-y-2 flex-col mt-1 sm:mt-2 "
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-col sm:flex-row space-x-0 space-y-2 sm:space-y-0 sm:space-x-2"
                                    },
                                    [
                                      _c(
                                        "select",
                                        {
                                          staticClass: "input rounded-xl",
                                          attrs: {
                                            onchange: "this.form.submit()",
                                            name: "status"
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                selected: "",
                                                disabled: "",
                                                value: ""
                                              }
                                            },
                                            [_vm._v("Status")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.filters["status"],
                                            function(filter) {
                                              return _c(
                                                "option",
                                                {
                                                  key: filter.id,
                                                  domProps: {
                                                    selected:
                                                      _vm.formParams[
                                                        "status"
                                                      ] === filter.id,
                                                    value: filter.id
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(filter.name) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          staticClass: "input rounded-xl",
                                          attrs: {
                                            onchange: "this.form.submit()",
                                            name: "country_of_origin_id"
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                selected: "",
                                                disabled: "",
                                                value: ""
                                              }
                                            },
                                            [_vm._v("Country of Origin")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.filters["countries_of_origin"],
                                            function(filter) {
                                              return _c(
                                                "option",
                                                {
                                                  key: filter.id,
                                                  domProps: {
                                                    selected:
                                                      parseInt(
                                                        _vm.formParams[
                                                          "country_of_origin_id"
                                                        ]
                                                      ) === filter.id,
                                                    value: filter.id
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(filter.name) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-col sm:flex-row space-x-0 space-y-2 sm:space-y-0 sm:space-x-2"
                                    },
                                    [
                                      _c(
                                        "select",
                                        {
                                          staticClass: "input rounded-xl",
                                          attrs: {
                                            onchange: "this.form.submit()",
                                            name: "hazard_id"
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                selected: "",
                                                disabled: "",
                                                value: ""
                                              }
                                            },
                                            [_vm._v("Associated Hazard")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.filters["related_hazards"],
                                            function(filter) {
                                              return _c(
                                                "option",
                                                {
                                                  key: filter.id,
                                                  domProps: {
                                                    selected:
                                                      parseInt(
                                                        _vm.formParams[
                                                          "hazard_id"
                                                        ]
                                                      ) === filter.id,
                                                    value: filter.id
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(filter.name) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          staticClass: "input rounded-xl",
                                          attrs: {
                                            onchange: "this.form.submit()",
                                            name: "incident_id"
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                selected: "",
                                                disabled: "",
                                                value: ""
                                              }
                                            },
                                            [_vm._v("Associated Incident")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.filters["related_incidents"],
                                            function(filter) {
                                              return _c(
                                                "option",
                                                {
                                                  key: filter.id,
                                                  domProps: {
                                                    selected:
                                                      parseInt(
                                                        _vm.formParams[
                                                          "incident_id"
                                                        ]
                                                      ) === filter.id,
                                                    value: filter.id
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(filter.name) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          this.slug === "incidents"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-col sm:flex-row space-x-0 space-y-2 sm:space-y-0 sm:space-x-2 mt-1 sm:mt-2 "
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      staticClass: "input rounded-xl",
                                      attrs: {
                                        onchange: "this.form.submit()",
                                        name: "hazard_id"
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            selected: "",
                                            disabled: "",
                                            value: ""
                                          }
                                        },
                                        [_vm._v("Associated Hazard")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.filters["related_hazards"],
                                        function(filter) {
                                          return _c(
                                            "option",
                                            {
                                              key: filter.id,
                                              domProps: {
                                                selected:
                                                  parseInt(
                                                    _vm.formParams["hazard_id"]
                                                  ) === filter.id,
                                                value: filter.id
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(filter.name) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      staticClass: "input rounded-xl",
                                      attrs: {
                                        onchange: "this.form.submit()",
                                        name: "terrorist_group_id"
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            selected: "",
                                            disabled: "",
                                            value: ""
                                          }
                                        },
                                        [_vm._v("Associated Terrorist Group")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.filters["terrorist_groups"],
                                        function(filter) {
                                          return _c(
                                            "option",
                                            {
                                              key: filter.id,
                                              domProps: {
                                                selected:
                                                  parseInt(
                                                    _vm.formParams[
                                                      "terrorist_group_id"
                                                    ]
                                                  ) === filter.id,
                                                value: filter.id
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(filter.name) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          Object.keys(_vm.formParams).length
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "text-xs text-gray-600 my-auto cursor-pointer min-w-max mx-auto py-3 sm:py-0 sm:mx-4 sm:pl-3 flex space-x-2",
                                  on: {
                                    click: function($event) {
                                      return _vm.clearFilters()
                                    }
                                  }
                                },
                                [
                                  _c("div", [_vm._v("Clear filters")]),
                                  _vm._v(" "),
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "w-4 my-auto fill-current",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 512 512"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.records
                      ? [
                          _vm.records.length
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex cap flex-col border rounded-xl bg-white p-1"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "bg-[#143642] p-1 px-2 w-full rounded-[9px] capitalize text-white text-sm font-medium"
                                    },
                                    [_vm._v(_vm._s(_vm.title))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-col space-y-4 pt-4 p-2"
                                    },
                                    [
                                      _vm._l(_vm.records, function(record) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "flex group w-full"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "min-w-max relative",
                                                  attrs: {
                                                    href: record.permalink
                                                  }
                                                },
                                                [
                                                  Object.prototype.hasOwnProperty.call(
                                                    record,
                                                    "active"
                                                  )
                                                    ? _c("img", {
                                                        staticClass:
                                                          "aspect-video rounded-lg w-32 object-contain",
                                                        attrs: {
                                                          src: record.image
                                                        }
                                                      })
                                                    : _c("img", {
                                                        staticClass:
                                                          "w-32 h-32 object-contain",
                                                        attrs: {
                                                          src: record.image
                                                        }
                                                      })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-col flex-grow px-3 space-y-1 my-auto min-w-0"
                                                },
                                                [
                                                  Object.prototype.hasOwnProperty.call(
                                                    record,
                                                    "active"
                                                  )
                                                    ? _c("div", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "flex"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "px-1 py-0.5 rounded-lg text-white uppercase tracking-[1px] text-xs ",
                                                                class: {
                                                                  "bg-[#73788d]": !record.active,
                                                                  "bg-[#b71111]":
                                                                    record.active
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    record.active
                                                                      ? "Active"
                                                                      : "Inactive"
                                                                  ) +
                                                                    "\n                                                "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm font-medium group-hover:text-[#E57722]",
                                                      attrs: {
                                                        href: record.permalink
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(record.name)
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass:
                                                      "!text-xs text-slate-800 line-clamp-4 description-preview",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        record.description_html
                                                      )
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "min-w-max my-auto",
                                                  attrs: {
                                                    href: record.permalink
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "fill-current text-[#E57722] w-2.5",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 320 512"
                                                      }
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d:
                                                            "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.records.length
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex w-full max-w-full justify-between flex-wrap"
                                },
                                [
                                  _vm.meta.last_page > 1 && _vm.currentPage > 1
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "text-xs p-1",
                                          attrs: {
                                            href: _vm.paginationLink(
                                              _vm.currentPage - 1
                                            )
                                          }
                                        },
                                        [_vm._v("← Previous")]
                                      )
                                    : _c("div", { staticClass: "w-12" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex max-w-[70%] flex-wrap -ml-1"
                                    },
                                    _vm._l(_vm.paginationRange, function(
                                      page,
                                      idx
                                    ) {
                                      return _c(
                                        "div",
                                        { key: idx },
                                        [
                                          page === "..."
                                            ? [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-xs ml-1"
                                                  },
                                                  [_vm._v("...")]
                                                )
                                              ]
                                            : [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "text-xs flex aspect-square bg-white border rounded ml-1 mb-1",
                                                    class: {
                                                      "text-[#E57722] font-medium":
                                                        _vm.currentPage ===
                                                        page,
                                                      "text-gray-600":
                                                        _vm.currentPage !== page
                                                    },
                                                    attrs: {
                                                      href: _vm.paginationLink(
                                                        page
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "w-7 text-center m-auto"
                                                      },
                                                      [_vm._v(_vm._s(page))]
                                                    )
                                                  ]
                                                )
                                              ]
                                        ],
                                        2
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _vm.currentPage < _vm.meta.last_page
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "text-xs p-1",
                                          attrs: {
                                            href: _vm.paginationLink(
                                              _vm.currentPage + 1
                                            )
                                          }
                                        },
                                        [_vm._v("Next →")]
                                      )
                                    : _c("div", { staticClass: "w-12" })
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.records.length
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "font-medium text-[#143642]" },
                            [
                              _vm._v(
                                "No results found matching your search query."
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ]
            : [
                _c("div", { staticClass: "w-full h-full flex" }, [
                  _c(
                    "div",
                    {
                      staticClass: "mx-auto flex flex-col mt-20",
                      attrs: { role: "status" }
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass:
                            "inline mx-auto w-14 h-14 text-[#143642] animate-spin fill-[#E57722]",
                          attrs: {
                            "aria-hidden": "true",
                            viewBox: "0 0 100 101",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                              fill: "currentColor"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d:
                                "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                              fill: "currentFill"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "font-medium text-[#143642] mt-4" },
                        [_vm._v("Searching CAT-UXO database...")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Loading...")
                      ])
                    ]
                  )
                ])
              ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h4", { staticClass: "mb-2 text-center" }, [
        _vm._v("Download the CAT-UXO App ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "app-download-buttons d-flex mb-4" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href:
                "https://apps.apple.com/by/app/cat-uxo/id6720751417?platform=iphone"
            }
          },
          [
            _c("img", {
              attrs: { src: "/img/download-on-the-app-store.png", alt: "" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://play.google.com/store/apps/details?id=com.catuxo.mobile&hl=en"
            }
          },
          [
            _c("img", {
              attrs: { src: "/img/get-it-on-google-play.png", alt: "" }
            })
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "control" }, [
      _c("button", {
        staticClass: "btn btn-search !rounded-tr-xl !rounded-br-xl"
      })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41d08c56", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41d08c56","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/PlatformHazardType.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-41d08c56","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/PlatformHazardType.vue
// module chunks = 0 1